import { html, rune, View } from 'rune-ts';
import klass from './StatisticsSection.module.scss';
import { typo, typoPcMo } from '../../../../../shared/typography/typo';

export class StatisticsSection extends View {
  constructor() {
    super({});
  }

  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    const texts = {
      statistics_title: html.preventEscape(
        ET(`mps2::landing::popup_store::${is_mobile ? 'mo_' : ''}statistics_title`),
      ),
      statistics_date: ET(`mps2::landing::popup_store::${is_mobile ? 'mo_' : ''}statistics_date`),
      statistics_creator_count: ET(
        `mps2::landing::popup_store::${is_mobile ? 'mo_' : ''}statistics_creator_count`,
      ),
      statistics_member_count: ET(
        `mps2::landing::popup_store::${is_mobile ? 'mo_' : ''}statistics_member_count`,
      ),
      statistics_product_category_count: ET(
        `mps2::landing::popup_store::${is_mobile ? 'mo_' : ''}statistics_product_category_count`,
      ),
      statistics_marpple_product_count: ET(
        `mps2::landing::popup_store::${is_mobile ? 'mo_' : ''}statistics_marpple_product_count`,
      ),
      statistics_brand_count: ET(
        `mps2::landing::popup_store::${is_mobile ? 'mo_' : ''}statistics_brand_count`,
      ),
      statistics_popupstore_count: ET(
        `mps2::landing::popup_store::${is_mobile ? 'mo_' : ''}statistics_popupstore_count`,
      ),
    };

    return html`
      <section class="${klass.statistics}">
        <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '48_bold', mo: '28_bold' })}">
          ${texts.statistics_title}
        </div>
        <div class="${klass.statistics}">
          <div class="${klass.date} ${typo('14_bold')}">
            ${texts.statistics_date}
          </div>
          <div class="${klass.statistics_row}">
            <div class="${klass.statistics_item}">
              <div class="${klass.sub_title} ${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_bold' })}">
                ${texts.statistics_creator_count}
              </div>
              <div class="${klass.row_title}">80,000+</div class="${klass.row_title}">
            </div>
            <div class="${klass.statistics_item}">
              <div class="${klass.sub_title} ${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_bold' })}">
                ${texts.statistics_member_count}
              </div>
              <div class="${klass.row_title}">1,700,000+</div class="${klass.row_title}">
            </div>
          </div>
          <div class="${klass.statistics_row}">
            <div class="${klass.statistics_item}">
              <div class="${klass.sub_title} ${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_bold' })}">
                ${texts.statistics_product_category_count}
              </div>
              <div class="${klass.row_title}">200+</div class="${klass.row_title}">
            </div>
            <div class="${klass.statistics_item}">
              <div class="${klass.sub_title} ${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_bold' })}">
                ${texts.statistics_marpple_product_count}
              </div>
              <div class="${klass.row_title}">530,000+</div class="${klass.row_title}">
            </div>
          </div>
          <div class="${klass.statistics_row}">
            <div class="${klass.statistics_item}">
              <div class="${klass.sub_title} ${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_bold' })}">
                ${texts.statistics_brand_count}
              </div>
              <div class="${klass.row_title}">40+</div class="${klass.row_title}">
            </div>
            <div class="${klass.statistics_item}">
              <div class="${klass.sub_title} ${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_bold' })}">
                ${texts.statistics_popupstore_count}
              </div>
              <div class="${klass.row_title}">200+</div>
            </div>
          </div>
        </div>
      </section>
    `;
  }
}
